// extracted by mini-css-extract-plugin
export default {"cls1":"yy3b9H7FwfTBa4mmihqg","cls2":"HvEi14YNf6cFewPT2KJl yy3b9H7FwfTBa4mmihqg"};